/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import React from 'react'
import Grid from '@mui/material/Grid'
import { Link } from 'react-router-dom';
import Container from '@mui/material/Container'
import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui';
import { IMAGES } from '../../config/assets';


// Footer component for the page
const PageFooter = () => {
  const { classes } = useStyles(); // Using custom styles

  return (
    <>
      {/* Footer section */}
      <div className={classes.root}>
        <Container maxWidth="xl" component="footer">
          <Grid container spacing={4} justify="space-evenly">
            {/* Empty grid space for layout alignment */}
            <Grid item xs={12} sm={12} md={2} />

            {/* Logo section */}
            <Grid item xs={12} sm={6} md={3}>
              <Link to="/">
                <img src={IMAGES.LOGO} alt="Logo" height="60px" />
              </Link>
            </Grid>

            {/* Footer links */}
            <Grid item xs={12} sm={6} md={7}>
              <Link to="/contact-us" className={classes.listItemLink}>
                <Typography variant="h4" color="white">
                  Contact us
                </Typography>
              </Link>
              <Link to="/about-us" className={classes.listItemLink}>
                <Typography variant="h4" color="white">
                  About us
                </Typography>
              </Link>
              <Link to="/privacypolicy" className={classes.listItemLink}>
                <Typography variant="h4" color="white">
                  Privacy Policy
                </Typography>
              </Link>
              <Link to="/tos" className={classes.listItemLink}>
                <Typography variant="h4" color="white">
                  Terms of use
                </Typography>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </div>

      {/* Footer copyright section */}
      <div className={classes.footerdiv}>
        <Typography variant="h4" align="center" color="white">
          Copyright
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.getchkd.com"
            className={classes.itemLink}
          >
            {new Date().getFullYear()} GetChkd.
          </a>
          {'  '}  All Rights Reserved. © GetChkd is a registered trademark of GetChkd Inc. U.S. Patents 11366916 and 12235977.
        </Typography>
      </div>
    </>
  );
};
// Custom styles using Material-UI's makeStyles
const useStyles = makeStyles({ name: { PageFooter } })((theme) => ({
  root: {
    position: 'relative',
    background: '#2b2c2e', // Dark background for footer
    paddingTop: '30px',
    color: 'white',
    marginTop: '200px',
    paddingBottom: theme.spacing(2),
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'left',
      paddingLeft: theme.spacing(3),
    },
  },
  footerdiv: {
    background: '#1c1d1f',
    paddingBottom: "10px"

  },
  listItemLink: {
    lineHeight: '25px',
    transition: 'all .25s cubic-bezier(.645,.045,.355,1)',
    textDecoration: 'none',
    color: 'white',
    width: 'fit-content',
    display: 'inline-block',
    marginLeft: '20px',
    marginTop: '16px',
  },
  itemLink: {
    lineHeight: '25px',
    transition: 'all .25s cubic-bezier(.645,.045,.355,1)',
    textDecoration: 'none',
    color: 'white',
    width: 'fit-content',
    display: 'inline-block',
    marginLeft: '10px',
    marginTop: '16px',
  },
}));


export default PageFooter;
